<aside class="aside-menu">
    <nav class="sidebar-nav">
        <ul class="nav">
            <li class="nav-title px-0">
                <div>
                    <p>Background Tasks </p>
                    <button *ngIf="auth.hasRole('super-admin')" class="btn btn-info p-1 btn-sm pull-right" (click)="showFilters()"><i class="fa fa-filter"></i> Search</button>
                    <button class="btn btn-danger p-1 btn-sm pull-right" (click)="clear()"><i class="fa fa-trash"></i> Clear</button>
                </div>
            </li>
            <li class="nav-item px-3 hidden-cn" *ngFor="let backgroundTask of backgroundTasks; trackBy: trackByFn">
                <div class="row">
                    <div class="col-md-10">
                        <div class="mb-1">
                            <small><b>{{backgroundTask.name}}</b></small>
                        </div>
                        <div class="mb-1">
                            <small>{{getCreatedAt(backgroundTask)}}</small>
                        </div>
                        <div class="progress progress-xs">
                            <div [attr.class]="getProgressClass(backgroundTask)" role="progressbar"
                                 [attr.class]="getProgressClass(backgroundTask)"
                                 [style.width]="getProgress(backgroundTask) + '%'"
                                 [attr.aria-valuenow]="getProgress(backgroundTask)"
                                 aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                        <div>
                            <small class="text-muted">Processed {{getProcessed(backgroundTask)}}
                                of {{backgroundTask.jobs.length}} task(s)</small>
                        </div>
                        <div>
                            <small class="text-muted" *ngIf="auth.hasRole('super-admin')">Created
                                By: {{backgroundTask.created_by ? backgroundTask.created_by.first_name : ''}} {{backgroundTask.created_by ? backgroundTask.created_by.last_name : ''}}</small>
                        </div>
                    </div>
                    <div class="col-md-2 pt-3">
                        <div class="spinner-border" role="status" *ngIf="getProgress(backgroundTask) < 100">
                            <span class="sr-only">Loading...</span>
                        </div>
                        <div *ngIf="getProgress(backgroundTask) == 100">
                            <i class="fa fa-file-download fa-lg"
                           (click)="downloadBackgroundTask(backgroundTask)"></i>
                        </div>
                        <div *ngIf="getProgress(backgroundTask) == 100">
                            <i class="fa fa-trash fa-lg text-danger pt-2"
                               (click)="deleteBackgroundTask(backgroundTask)"></i>
                        </div>
                    </div>
                </div>
            </li>
            <li class="nav-item py-1">
                <nav aria-label="Page navigation example" *ngIf="pageCount">
                    <ul class="pagination">
                        <li class="page-item" [class.disabled]="isFirstPage()">
                            <a class="page-link" (click)="firstPage()"><<</a>
                        </li>
                        <li class="page-item" [class.disabled]="isFirstPage()">
                            <a class="page-link" (click)="prevPage()"><</a>
                        </li>
                        <li class="page-item" *ngFor="let pageNum of pages" [class.active]="pageNum == page">
                            <a class="page-link" (click)="setPage(pageNum)">{{pageNum}}</a>
                        </li>
                        <li class="page-item" [class.disabled]="isLastPage()">
                            <a class="page-link" (click)="nextPage()">></a>
                        </li>
                        <li class="page-item" [class.disabled]="isLastPage()">
                            <a class="page-link" (click)="lastPage()">>></a>
                        </li>
                    </ul>
                </nav>
            </li>
        </ul>
    </nav>
</aside>
